import { useTranslation } from 'react-i18next';
import Button from '~components/Atoms/Button';
import ErrorBlock from '~components/Atoms/ErrorBlock';
import ErrorImage from '~components/Atoms/ErrorImage';
import Unescaped from '~components/Atoms/Unescaped';
import HeartRate from '~components/icons/heart-rate';
import KoFace from '~components/icons/ko_face';
import RespiratoryRate from '~components/icons/respiratory-rate';

function NotFoundPage() {
  const { t } = useTranslation();

  const title = t('error_404_title');
  const message = t('error_404_message_html');

  function close() {
    console.debug('Close app');
  }

  return (
    <div className="w-screen h-screen bg-surface-neutral p-8 flex flex-col items-center text-surface-surface-error">
      <Button onClick={close} priority="close" content="x" className="self-end" />
      <div className="flex-grow flex flex-col justify-center items-center">
        <h1>{title}</h1>
        <ErrorImage>
          <ErrorBlock position="left" icon={<HeartRate width={48} height={48} />}>
            404
          </ErrorBlock>
          <KoFace />
          <ErrorBlock icon={<RespiratoryRate width={48} height={48} />}>xx</ErrorBlock>
        </ErrorImage>
        <p className="text-center">
          <Unescaped>{message}</Unescaped>
        </p>
      </div>
    </div>
  );
}

export default NotFoundPage;
